module.exports = __webpack_public_path__ + "img/nl.454de89e.svg";